import { render } from "./CourseOrientedCrb.vue?vue&type=template&id=242c5056&scoped=true"
import script from "./CourseOrientedCrb.vue?vue&type=script&lang=js"
export * from "./CourseOrientedCrb.vue?vue&type=script&lang=js"

import "./CourseOrientedCrb.vue?vue&type=style&index=0&id=242c5056&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-242c5056"]])

export default __exports__